namespace('compass.hotel');

// Sub-widget Definition
compass.hotel.SimplifiedHotelFilterAdditionalFilters = compass.defineWidget(function SimplifiedHotelFilterAdditionalFilters(options) {
	var me = this;
	var settings = options;
	var $j = jQuery;
	var d = $j.dom;

	// NOTE: The 'backer element' is an invisible rectangle that covers everything
	// except for the Additional Filters container. This element is used solely
	// to detect clicks outside of the Additional Filters container to know that
	// the Additional Filters container should be closed and to prevent other
	// elements on the page from being triggered when trying to click outside of
	// the Additional Filters

	var containerElement;
	var backerElement;
	var priceFilterElement;
	var starFilterElement;
	var roomCountFilterElement;
	var amenityListElement;
	var tagWrapperElement;
	var clearButton;

	var minPriceInput;
	var maxPriceInput;
	var roomCountInput;
	var starRatingSelectors;
	var previousFilterObjects = settings.previousFilterObjects;
	var promotions = settings.promotions;
	var chainFilterActive = false;
	var ecoFilterActive = false;

	// amenity name <-> code mapping. Array instead of Object to retain order
	var amenityTypeMap = [
		{name: 'Business Center', code: 'Business Center', icon: 'fa-solid fa-briefcase'},
		{name: 'Complimentary Breakfast', code: 'Complimentary Breakfast', icon: 'fa-solid fa-mug-saucer'},
		{name: 'Fitness Center', code: 'Fitness Center', icon: 'fa-solid fa-dumbbell'},
		{name: 'Free Wifi', code: 'Free Wireless Internet', icon: 'fa-solid fa-wifi'},
		{name: 'Parking Availability', code: 'Parking', icon: 'fa-solid fa-car'},
		{name: 'Pool', code: 'Pool', icon: 'fa-solid fa-person-swimming'},
		{name: 'Restaurant', code: 'Restaurant', icon: 'fa-solid fa-utensils'},
		{name: 'Shuttle Service', code: 'Shuttle Service', icon: 'fa-solid fa-van-shuttle'}
	];

	// top-level methods that exist in the main Filter widget
	var mainFilter = settings.mainFilterWidget;
	var generateFilterKey = mainFilter.generateFilterKey;
	var dispatchChange = mainFilter.dispatchChange;

	// Extend the 'updateFilter' function to do some extra stuff
	var updateFilter = function(key, label, value, type) {
		mainFilter.updateFilter(key, label, value, type);
		filterChangeHandler();
	};

	// Extend the 'unsetFilter' function to do some extra stuff
	var unsetFilter = function(key) {
		mainFilter.unsetFilter(key);
		filterChangeHandler();
	};

	// Determine if 'clear all' button should be enabled. Also, update the displayed tags
	var filterChangeHandler = function() {
		updateTags();
		mainFilter.occupancy = Math.max(0, parseInt(roomCountInput.val())) || undefined;
		var clearable = false;
		// price filter inputs
		var minPriceFilter = $(priceFilterElement).find('.minPriceInput');
		var maxPriceFilter = $(priceFilterElement).find('.maxPriceInput');
		if (minPriceFilter.val() !== '' || maxPriceFilter.val() !== '') {
			clearable = true;
		}
		// star filter input
		if ($('.starSelector.selected').length > 0) {
			clearable = true;
		}
		// room count input
		if (roomCountInput.val() !== '1') {
			clearable = true;
		}
		// amenity checkboxes
		if ($(amenityListElement).find(":checked").length > 0) {
			clearable = true;
		}
		// promotions checkboxes
		if ($('.promotionsListWrapper').find(":checked").length > 0) {
			clearable = true;
		}
		// chain filter, set via event bind
		if (chainFilterActive === true) {
			clearable = true;
		}
		// eco filter, set via event bind
		if (ecoFilterActive === true) {
			clearable = true;
		}

		// if 'clearable' was set true, enable the clear button
		if (clearable) {
			clearButton.removeClass('disabled');
			me.trigger('SimplifiedHotelFilterWidget.setClearButtonVisible', true);
		} else {
			clearButton.addClass('disabled');
			me.trigger('SimplifiedHotelFilterWidget.setClearButtonVisible', false);
		}
	};

	me.bind('SimplifiedHotelFilterAdditionalFilters.filterChangeHandler', function(event,eventData) {
		filterChangeHandler();
	});

	me.bind('SimplifiedHotelFilterAdditionalFilters.setChainFilterActive', function(event,eventData) {
		chainFilterActive = eventData;
		filterChangeHandler();
	});

	me.bind('SimplifiedHotelFilterAdditionalFilters.setEcoFilterActive', function(event,eventData) {
		ecoFilterActive = eventData;
		filterChangeHandler();
	});

	// When pressing 'Clear All', every filter should be unset or reset to default
	me.clearFilters = function() {
		unsetFilter(minPriceInput.key);
		unsetFilter(maxPriceInput.key);
		if (settings.displayHotelStars) {
			unsetFilter(starRatingSelectors.key);
			clearStarRatingButtons();
		}
		clearNumberOfRooms();
		clearAmenityCheckboxes();
		dispatchChange(150);
		filterChangeHandler();
		me.trigger('SimplifiedHotelFilterWidget.clearButton');
	};

	// Hide additional filters
	var closeContainer = function() {
		$(containerElement).css('visibility', 'hidden');
		$(backerElement).css('visibility', 'hidden');
		$('.additionalFilterButton').focus();
		dispatchChange(150);
	};

	// Show additional filters
	var openContainer = function() {
		if (mainFilter.filtersLocked) {
			return;
		}
		$(containerElement).on('keyup', function(evt) {
			if (evt.keyCode === 27) {
				closeContainer();
			}
		});
		$(containerElement).css('visibility', 'visible');
		$(backerElement).css('visibility', 'visible');
		$('.minPriceInput').focus();
	};

	/* Render the entire widget's contents */
	me.render = function(widgetElem) {
		return widgetElem.append(
			me.drawButton(),
			me.drawContainer([
				me.drawHeader(),
				me.drawPriceFilter(),
				me.drawStarFilter(),
				me.drawRoomCountFilter(),
				me.drawAmenities(),
				me.drawClearButton()
			]),
			me.drawTags()
		);
	};

	me.drawButton = function() {
		var button = d.div(
			{
				className : 'additionalFilterButton roundedContainer',
				role : 'button',
				'ARIA-role' : 'button',
				'ARIA-label' : 'Show Additional Filters',
				tabindex : 0
			},
			d.i({className:'filterIcon fa-solid fa-bars-filter'}),
			'Additional Filters'
		);
		button.activate(openContainer);
		return button;
	};

	me.drawContainer = function(content) {
		containerElement = d.div({className: 'additionalFilterContainer roundedContainer'}, content);
		backerElement = d.div({className:'additionalFilterBacker'});
		backerElement.click(closeContainer);
		return [backerElement, containerElement];
	};

	me.drawHeader = function() {
		var closeButton = d.button({className: 'closeButton fa-solid fa-xmark'});
		closeButton.activate(closeContainer);
		var header = [
			d.h1(
				{className: 'additionalFilterHeader'},
				'Additional Filters'
			),
			closeButton,
			d.div({className : 'clear'})
		];
		return header;
	};


	me.drawClearButton = function() {
		clearButton = d.button(
			{className: 'additionalFilterClearButton disabled'},
			'Clear All Filters'
		);

		clearButton.activate(function() {
			me.clearFilters();
			compass.GA.trackEvent('New Filters', 'Clear All Filters', 'Clear Within Menu');
		});

		return clearButton;
	};

	// Price Filters
	me.drawPriceFilter = function() {
		var minPriceKey = generateFilterKey();
		var maxPriceKey = generateFilterKey();

		// Minimum price input
		minPriceInput = d.input({
			className	: 'additionalFilter minPriceInput ' + minPriceKey,
			type		: 'text',
			value		: '',
			maxlength	: 7,
			placeholder	: 'Minimum',
			autocomplete: 'off',
			id			: compass.generateId()
		});
		minPriceInput.key = minPriceKey;
		// Apply filter when done interacting with the input
		minPriceInput.change(function(evt) {
			var minimumPrice = parseInt(minPriceInput.val()) || 0;
			var maximumPrice = parseInt(maxPriceInput.val()) || Infinity;
			// alert when Minimum is above/equal-to Maximum
			if (minimumPrice >= maximumPrice) {
				d.alert('Minimum should not be equal to or greater than maximum');
				minPriceInput.val('');
			} else if (minimumPrice === 0) {
				unsetFilter(minPriceKey);
				dispatchChange(150);
				compass.GA.trackEvent('New Filters', 'Your Budget - Minimum', 'Clear Minimum');
			} else {
				updateFilter(minPriceKey, 'minRangePrice', minPriceInput.val());
				dispatchChange(150);
			}
		});
		// Only accept positive whole numbers while typing
		minPriceInput.keyup(function(evt) {
			var numbersOnly = minPriceInput.val().replace(/[^0-9]/g, '');
			minPriceInput.val(numbersOnly);
		});
		// When clicking back in, clear out current value
		minPriceInput.click(function(evt) {
			if (minPriceInput.val()) {
				unsetFilter(minPriceKey);
				dispatchChange(150);
				// re-focus to prevent placeholder text from popping up
				minPriceInput.blur();
				minPriceInput.focus();
				compass.GA.trackEvent('New Filters', 'Your Budget - Minimum', 'Clear Minimum');
			}
		});

		// Max price input
		maxPriceInput = d.input({
			className	: 'additionalFilter maxPriceInput ' + maxPriceKey,
			type		: 'text',
			value		: '',
			maxlength	: 7,
			placeholder	: 'Maximum',
			autocomplete: 'off',
			id			: compass.generateId()
		});
		maxPriceInput.key = maxPriceKey;
		// Apply filter when done interacting with the input
		maxPriceInput.change(function(evt) {
			var minimumPrice = parseInt(minPriceInput.val()) || 0;
			var maximumPrice = parseInt(maxPriceInput.val()) || Infinity;
			// alert when Maximum is not above Minimum
			if (minimumPrice >= maximumPrice) {
				d.alert('Maximum should not be equal to or lesser than minimum');
				maxPriceInput.val('');
			} else if (!isFinite(maximumPrice)) {
				unsetFilter(maxPriceKey);
				dispatchChange(150);
				compass.GA.trackEvent('New Filters', 'Your Budget - Maximun', 'Clear Maximum');
			} else {
				updateFilter(maxPriceKey, 'maxRangePrice', maxPriceInput.val());
				dispatchChange(150);
			}
		});
		// Only accept positive whole numbers while typing
		maxPriceInput.keyup(function(evt) {
			var numbersOnly = maxPriceInput.val().replace(/[^0-9]/g, '');
			maxPriceInput.val(numbersOnly);
		});
		// When clicking back in, clear out current value
		maxPriceInput.click(function(evt) {
			if (maxPriceInput.val()) {
				unsetFilter(maxPriceKey);
				dispatchChange(150);
				// re-focus to prevent placeholder text from popping up
				maxPriceInput.blur();
				maxPriceInput.focus();
				compass.GA.trackEvent('New Filters', 'Your Budget - Maximun', 'Clear Maximum');
			}
		});

		// custom styling to outline the wrapper element instead of the sub-input
		minPriceInput.focus(function(evt) {
			minInputWrapper.addClass('inputFocused');
		});
		minPriceInput.blur(function(evt) {
			minInputWrapper.removeClass('inputFocused');
		});
		maxPriceInput.focus(function(evt) {
			maxInputWrapper.addClass('inputFocused');
		});
		maxPriceInput.blur(function(evt) {
			maxInputWrapper.removeClass('inputFocused');
		});

		// Wrapper for the inputs
		var minInputWrapper = d.div(
			{className: 'priceInputWrapper roundedContainer'},
			d.div({className: 'priceInputCurrencySymbol'}, settings.currencySymbol),
			minPriceInput
		);
		var maxInputWrapper = d.div(
			{className: 'priceInputWrapper roundedContainer'},
			d.div({className: 'priceInputCurrencySymbol'}, settings.currencySymbol),
			maxPriceInput
		);
		var inputContainer = d.div(
			{className: 'inputContainer'},
			minInputWrapper, d.div({className: 'middleIcon'}, '-'), maxInputWrapper
		);
		priceFilterElement = d.div(
			{className: 'additionalFilterPriceWrapper'},
			d.h2('Your Budget'),
			d.div({className: 'infoNote'}, 'Per night'),
			inputContainer
		);
		return [priceFilterElement, d.div({className : 'clear'})];
	};

	// Star Filter
	me.drawStarFilter = function() {
		if (!settings.displayHotelStars) {
			return {};
		}
		var star_rating_key = generateFilterKey();
		starRatingSelectors = d.div(
			{
				className: 'starSelectorContainer',
				role: 'radiogroup'
			},
			drawStarRatingButton(star_rating_key, 1),
			drawStarRatingButton(star_rating_key, 2),
			drawStarRatingButton(star_rating_key, 3),
			drawStarRatingButton(star_rating_key, 4),
			drawStarRatingButton(star_rating_key, 5)
		);
		starRatingSelectors.key = star_rating_key;
		starFilterElement = d.div(
			{className: 'additionalFilterStarWrapper'},
			d.h2('Star Rating'),
			d.div(
				{className : 'starFilterInfo', title : 'The star rating a hotel receives is determined by a third party.'},
				'<i class="icon-info-sign fa-solid fa-circle-info"></i>' // TODO: update to 'circle-info' when upgrading fontawesome
			),
			starRatingSelectors
		);
		return [starFilterElement, d.div({className : 'clear'})];
	};

	var drawStarRatingButton = function(filter_key, index) {
		var button = d.div(
			{
				className: 'starSelector roundedContainer star_' + index,
				tabindex: 0,
				role: 'radio'
			},
			index + ' <i class="starIcon fa-solid fa-star"></i>'
		);
		button.activate(function(evt) {
			// need to know if this button was already the selected one
			var wasSelected = $(button).hasClass('selected');
			// deselect all star rating options
			clearStarRatingButtons();
			// 'select' the button if it wasn't previously selected
			if (!wasSelected) {
				$(button).addClass('selected');
				updateFilter(filter_key, 'starCutoff', index);
			} else {
				unsetFilter(filter_key);
			}
			dispatchChange(150);
		});
		return button;
	};

	var clearStarRatingButtons = function() {
		var selectorElements = me.find('.starSelector');
		for (var i in selectorElements) {
			selectorElements.eq(i).removeClass('selected');
		}
	};

	me.drawRoomCountFilter = function() {
		roomCountFilterElement = d.div(
			{className: 'additionalFilterRoomCountWrapper'},
			d.h2('Rooms Needed'),
			drawNumberSpinner(),
			d.div({className: 'roomCountHelperText'}, 'To adjust the rooms needed, click the “+” or “-” button, or click into the number box.')
		);
		return [roomCountFilterElement, d.div({className : 'clear'})];
	};

	var drawNumberSpinner = function() {
		var roomCountKey = generateFilterKey();
		roomCountInput = d.input({
			type: 'number',
			value: 1,
			min: 1,
			max: settings.maxRooms,
			step: 1,
			maxlength: 3,
		});
		roomCountInput.key = roomCountKey;
		var lastValidValue = 1;
		roomCountInput.focus(function() {
			roomCountInput.val('');
			me.find('.spinnerInputWrapper').addClass('inputFocused');
		});
		roomCountInput.change(function() {
			var newValue = roomCountInput.val();

			// If the user has manually typed a non integer manually
			if (Number.isInteger(newValue) === false) {
				newValue = Math.floor(newValue);
				if (Number.isNaN(newValue)) {
					newValue = lastValidValue;
				}
				roomCountInput.val(newValue);
			}

			if (newValue < 1) {
				d.alert('You cannot enter a number less than 1');
				roomCountInput.val(1).change();
			} else if (newValue > settings.maxRooms) {
				d.alert('You have exceeded the maximum number of rooms');
				roomCountInput.val(settings.maxRooms).change();
			} else {
				if (newValue == 1) { // deliberately a 'soft equality' check
					unsetFilter(roomCountKey);
				} else {
					updateFilter(roomCountKey, 'availability', newValue);
				}
				lastValidValue = newValue;
				dispatchChange();
			}
		});
		roomCountInput.blur(function() {
			if (roomCountInput.val() === '') {
				roomCountInput.val(lastValidValue).change();
			}
			me.find('.spinnerInputWrapper').removeClass('inputFocused');
		});

		return d.div(
			{className: 'spinnerWrapper'},
			d.button({className: 'spinnerDown', tabindex: -1}, d.i({className: 'icon-minus fa-solid fa-minus'})).click(function(evt) {
				roomCountInput[0].stepDown();
				roomCountInput.change();
				compass.GA.trackEvent('New Filters', 'Rooms needed', 'Subtract 1 Room');
			}),
			d.div({className: 'spinnerInputWrapper roundedContainer'}, roomCountInput),
			d.button({className: 'spinnerUp', tabindex: -1},d.i({className: 'icon-plus fa-solid fa-plus'})).click(function(evt) {
				roomCountInput[0].stepUp();
				roomCountInput.change();
				compass.GA.trackEvent('New Filters', 'Rooms needed', 'Add 1 Room');
			})
		);
	};

	var clearNumberOfRooms = function() {
		roomCountInput.val(1);
		unsetFilter(roomCountInput.key);
	};

	// Amenity Filter
	me.drawAmenities = function() {
		amenityListElement = d.div(
			{className: 'additionalFilterAmenityWrapper'},
			d.h2('Amenities'),
			d.div({className : 'amenitiesHelperText'}, 'Filter by amenities offered by the hotel:'),
			d.ul(
				{className : 'amenities'},
				$.map(amenityTypeMap, function(elem, index) {
					var key = generateFilterKey();
					var labelId = compass.generateId();
					return d.li(
						{className : 'amenity'},
						d.label(
							{'for': labelId, tabindex: 0},
							d.div({className : 'pseudoCheckbox ' + key},
								d.input({
									className : 'amenityItem ' + key,
									type : 'checkbox',
									value : elem.code,
									'ARIA-labelledby' : labelId,
									id: labelId,
									tabindex: -1
								}).change(updateFilterAmenity(key, 'amenity')),
								d.div({className : 'pseudoCheckmark'}),
								d.span({id: labelId}, elem.name)
							)
						).bind('keydown', function(e) {
							if(e.keyCode == 13 || e.keyCode == 32) {
								$j(this).trigger('click');
								$j(this).focus();
								return false;
							}
						})
					);
				})
			)
		);
		return [amenityListElement, d.div({className : 'clear'})];
	};

	var updateFilterAmenity = function(key, type, value) {
		return function() {
			var check = $(this);
			var val = check.val();
			if(check.is(':checked')) {
				updateFilter(key, value || val, true, type);
			} else {
				unsetFilter(key);
			}
			dispatchChange();
		};
	};

	var clearAmenityCheckboxes = function() {
		var selectedAmenityList = amenityListElement.find("input:checked");
		for (var index = 0; index < selectedAmenityList.length; ++index) {
			var item = selectedAmenityList.eq(index);
			item.prop('checked', false);
			var key = item.attr('class').split(" ")[1];
			unsetFilter(key);
		}
	};

	// the specific purpose of a filter can be found either in `key` or `type`, depending on the filter
	var getFilterObjectType = function(filterObject) {
		return (filterObject.type === 'generic') ? filterObject.key : filterObject.type;
	};

	// Tag container
	me.drawTags = function() {
		tagWrapperElement = updateTags();
		return tagWrapperElement;
	};

	// generate tag elements based on the currently applied filters
	var updateTags = function() {
		var currFilter = mainFilter.cloneCurrentFilterObject();
		// note: for many of the functions in this file, params named `filterObject`
		// will typically refer to the data generated here
		var filterObjects = [];
		var filterObjectKeys = Object.keys(currFilter);
		for (var index in filterObjectKeys) {
			var key = filterObjectKeys[index];
			var obj = currFilter[key];
			obj.filter_id = key;
			filterObjects.push(obj);
		}
		// use the previous filter object array to maintain order of existing filters
		var spliceIndex = 0;
		for (var prevObjectIndex in previousFilterObjects) {
			var previousObject = previousFilterObjects[prevObjectIndex];
			for (var newObjectIndex in filterObjects) {
				var newObject = filterObjects[newObjectIndex];
				if (newObject.filter_id === previousObject.filter_id) {
					// remove from current position & place at desired position
					filterObjects.splice(newObjectIndex, 1);
					filterObjects.splice(spliceIndex, 0, newObject);
					spliceIndex++;
				}
			}
		}
		// if minPrice & maxPrice are both present, they should be grouped at the lowest index of the two
		var firstPriceIndex = -1;
		for (var index in filterObjects) {
			var filterObject = filterObjects[index];
			var filterType = getFilterObjectType(filterObject);
			if (filterType === 'minRangePrice' || filterType === 'maxRangePrice') {
				if (firstPriceIndex >= 0) {
					filterObjects.splice(index, 1);
					filterObjects.splice(firstPriceIndex, 0, filterObject);
					break;
				}
				firstPriceIndex = index;
			}
		}
		// persist the filter objects to be checked against next time tags are updated
		previousFilterObjects = filterObjects;
		mainFilter.handleUpdatePreviousFilterObjects(filterObjects);

		// generate elements based on the filter objects
		var elementArray = [];
		var minPriceObject, maxPriceObject;
		var priceTagIndex = -1;
		for (var i = 0; i < filterObjects.length; ++i) {
			var filterObject = filterObjects[i];
			switch(getFilterObjectType(filterObject)) {
				case 'minRangePrice':
					minPriceObject = filterObject;
					priceTagIndex = (priceTagIndex == -1) ? elementArray.length : priceTagIndex;
					break;
				case 'maxRangePrice':
					maxPriceObject = filterObject;
					priceTagIndex = (priceTagIndex == -1) ? elementArray.length : priceTagIndex;
					break;
				case 'amenity':
					elementArray.push(drawTagAmenity(filterObject));
					break;
				case 'starCutoff':
					elementArray.push(drawTagStar(filterObject));
					break;
				case 'availability':
					elementArray.push(drawTagRooms(filterObject));
					break;
				case 'promo':
					elementArray.push(drawTagPromo(filterObject));
					break;
				// no default; the intended default is to do nothing
			}
		}
		// the price tag element has to be created after iterating the filter array
		if (priceTagIndex !== -1) {
			elementArray.splice(priceTagIndex, 0, drawTagPrice(minPriceObject, maxPriceObject));
		}
		// wipe out the old tags & populate with the new ones
		tagWrapperElement = tagWrapperElement ? tagWrapperElement : d.div({className: 'filterTagWrapper'});
		tagWrapperElement.empty();
		tagWrapperElement.append(elementArray);
		return tagWrapperElement;
	};

	// generate a tag element with variable input content
	var createTagElement = function(className) {	
		className = (className === undefined) ? '' : className;
		var content = [];
		for (var i = 1; i < arguments.length; ++i) {
			content.push(arguments[i]);
		}
		var div = d.div(
			{className: 'filterTag roundedContainer ' + className},
			d.span(content),
			d.i({className: 'icon-remove fa-solid fa-xmark tagCloseButton', role: 'button', tabindex: 0})
		);
		return div;
	};

	// tag element with Amenity formatting (plain text)
	var drawTagAmenity = function(filterObject) {
		var displayText = filterObject.key;
		for (var i = 0; i < amenityTypeMap.length; ++i) {
			var nameCodePair = amenityTypeMap[i];
			if (nameCodePair.code === filterObject.key) {
				displayText = nameCodePair.name;
				icon = nameCodePair.icon;
				break;
			}
		}
		var tagDiv = createTagElement('tagAmenity', d.i({className: icon}), displayText);
		tagDiv.find('.tagCloseButton').activate(function() {
			compass.GA.trackEvent('New Filters', 'Filter Tags', 'Remove ' + filterObject.key + ' Amenity');
			unsetFilter(filterObject.filter_id);
			dispatchChange();
			tagDiv.remove();
		});
		return tagDiv;
	};

	// tag element with Promotion formatting (plain text)
	var drawTagPromo = function(filterObject) {
		var displayText = filterObject.key;
		// do not draw a tag for all exclusive promotions
		if (displayText == 'All Exclusive Promotions') return;

		for (var i = 0; i < promotions.length; ++i) {
			var nameCodePair = promotions[i];
			if (nameCodePair.code === filterObject.key) {
				displayText = nameCodePair;
				break;
			}
		}
		var tagDiv = createTagElement('tagPromo', d.i({className: 'fa-sharp fa-solid fa-award'}), displayText);
		tagDiv.find('.tagCloseButton').click(function() {
			compass.GA.trackEvent('New Filters', 'Filter Tags', 'Remove ' + filterObject.key + ' Promo');
			unsetFilter(filterObject.filter_id);
			// check to see if All Exclusive Promotions is selected and if so remove as well
			var currFilter = mainFilter.cloneCurrentFilterObject();
			for (var filterKey in currFilter) {
				if (currFilter[filterKey].key == 'All Exclusive Promotions') unsetFilter(filterKey);
			}
			dispatchChange();
			tagDiv.remove();
		});
		return tagDiv;
	};

	// tag element with Price formatting ($Min - $Max)
	var drawTagPrice = function(minPriceFilterObject, maxPriceFilterObject) {
		var currencySymbol = settings.currencySymbol;
		var displayText = (
			minPriceFilterObject
			? currencySymbol + String(minPriceFilterObject.value)
			: 'Min'
		);
		displayText += ' - ' + (
			maxPriceFilterObject
			? currencySymbol + String(maxPriceFilterObject.value)
			: 'Max'
		);
		var tagDiv = createTagElement('tagPrice', displayText);
		tagDiv.find('.tagCloseButton').click(function() {
			if (minPriceFilterObject) {
				unsetFilter(minPriceFilterObject.filter_id);
			}
			if (maxPriceFilterObject) {
				unsetFilter(maxPriceFilterObject.filter_id);
			}
			compass.GA.trackEvent('New Filters', 'Filter Tags', 'Remove Price');
			dispatchChange();
			tagDiv.remove();
		});
		return tagDiv;
	};

	// tag element with Star Rating formatting (Rating# + Star Icon)
	var drawTagStar = function(filterObject) {
		var tagDiv = createTagElement('tagStar', filterObject.value, d.i({className: 'starIcon fa-solid fa-star'}), '+');
		tagDiv.find('.tagCloseButton').click(function() {
			compass.GA.trackEvent('New Filters', 'Filter Tags', 'Remove ' + filterObject.value.toString() + ' Star');
			unsetFilter(filterObject.filter_id);
			clearStarRatingButtons();
			dispatchChange();
			tagDiv.remove();
		});
		return tagDiv;
	};

	// tag element with Room Availaibilty formatting (# Rooms)
	var drawTagRooms = function(filterObject) {
		var tagDiv = createTagElement('tagAvailability', String(filterObject.value) + ' Rooms');
		tagDiv.find('.tagCloseButton').click(function() {
			compass.GA.trackEvent('New Filters', 'Filter Tags', 'Remove ' + filterObject.value.toString() + ' Rooms');
			clearNumberOfRooms();
			dispatchChange();
			tagDiv.remove();
		});
		return tagDiv;
	};
	
}, {
	WUID : 'SimplifiedHotelFilterAdditionalFilters',
	widgetName : 'SimplifiedHotelFilterAdditionalFilters',
	mainFilterWidget : {},
	displayHotelStars : true,
	maxRooms: 20,
	currencySymbol: '$'
});
